import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { FiChevronDown as ChevronDown } from 'react-icons/fi';

export const Container = styled.div`
  display: inline-flex;
  position: relative;
`;

export const Icon = styled(ChevronDown)`
  position: absolute;
  pointer-events: none;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  top: 1rem;
  right: 0.6875rem;
`;

export const Selector = styled.select`
  width: 3.5rem;
  height: 3rem;
  background-color: ${({ theme }) => theme.colors.navyGreenLight};
  color: ${({ theme }) => theme.colors.navyGreen};
  font-size: 1.1875rem;
  border: none;
  align-items: center;
  appearance: none;
  cursor: pointer;
  display: inline-flex;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  border-radius: 0.75rem;
`;
